import React, {Fragment, useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import MachineDeleteForm from "./MachineDeleteForm";
import MachineUpdateForm from "./MachineUpdateForm";
import MachineCreateForm from "./MachineCreateForm";
import MachineItem from "./MachineItem";
import {getMachines} from "../../actions/machine";
import SearchForm from "../layout/SearchForm";
import {Plus} from "react-feather";
import TableSpinner from "../layout/TableSpinner";
import CustomPaginationWithManyPages from "../layout/CustomPaginationWithManyPages";
import { usePermission } from '../../hooks/usePermission';
import FilterByFirm from "../filters/FilterByFirm";

const Machines = () => {
    const { userCan } = usePermission();
    const dispatch = useDispatch();
    const {machines, loading, numberOfPages, currentPage, total_machines} = useSelector(state => state.machine);
    const [show, setShow] = useState(false);

    useEffect(() => {
        dispatch(getMachines());
    }, [dispatch]);

    if (!userCan('browse machines')) {
        return <div>You don't have permission to view machines.</div>;
    }

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <Fragment>
            <div className="container-fluid p-0">
                <div className="row mb-2">
                    <div className="col-md-12 col-lg-8">
                        <h1 className="h3 mb-3"><strong></strong> Uskunalar ({total_machines || 0}) </h1>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-3">
                        <FilterByFirm getPageItems={getMachines}/>
                    </div>
                    <div className="col-md-3">
                        <SearchForm getPageItems={getMachines}/>
                    </div>

                    <div className="col-md-6">
                        <div className="crud_actions text-end">
                            {userCan('add machines') && (
                                <button className="btn btn-primary" onClick={handleShow}>
                                    Uskuna <Plus/>
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                <div className="row mt-2">
                    <div className="col-xl-12 col-xxl-12 d-flex">
                        <div className="card w-100 table-responsive">
                            {loading && <TableSpinner/>}
                            <table className="table custom-table table-hover">
                                <thead className="table-light">
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Nomi</th>
                                    <th scope="col">Model</th>
                                    <th scope="col">Seriya raqami</th>
                                    <th scope="col">Firma</th>
                                    <th scope="col">Operator</th>
                                    <th scope="col">Holati</th>
                                    <th scope="col">Amallar</th>
                                </tr>
                                </thead>
                                <tbody>
                                {machines && machines.map((item, index) => (
                                    <MachineItem 
                                        key={item.id} 
                                        number={index + 1} 
                                        machine={item}
                                    />
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xl-12 col-xxl-12 d-flex">
                            <CustomPaginationWithManyPages
                                numberOfPages={numberOfPages}
                                getPageItems={getMachines}
                                current_page={currentPage}
                            />
                        </div>
                </div>
            </div>

            {userCan('add machines') && (
                <MachineCreateForm 
                    show={show} 
                    handleClose={handleClose}
                />
            )}

            {userCan('edit machines') && (
                <MachineUpdateForm/>
            )}

            {userCan('delete machines') && (
                <MachineDeleteForm/>
            )}
        </Fragment>
    );
};

export default Machines; 